import React, { useEffect, useRef, useState } from "react";
import { Grid, Modal } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import "./printcss.css";
import ModalHeaderStyle from "../utility/component/styles/modalHeader";
import moment from "moment";

const OrderReceiptModal = ({ open, onClose, printData }) => {
  const printRef = useRef();
  const [details, setDetails] = useState([]);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Order Receipt",
  });

  const calcTotal = (rows) => rows.reduce((sum, row) => sum + row.AMOUNT, 0);

  useEffect(() => {
    if (printData[0]) {
      const uniqueAccountNumbers = [
        ...new Set(printData.map((item) => item.ACCOUNT_NO)),
      ];
      let data = [];
      for (let index = 0; index < uniqueAccountNumbers.length; index++) {
        const filterItems = printData.filter(
          (p) => p.ACCOUNT_NO === uniqueAccountNumbers[index]
        );

        data[index] = {
          name: filterItems[0].NAME,
          items: filterItems,
        };
      }

      setDetails(data);
    }
  }, [printData]);
  return (
    <Modal open={open} onClose={onClose}>
      <div className="flex justify-center items-center h-screen w-screen">
        <div className="relative bg-white rounded-lg w-[850px] h-[90vh] shadow-xl flex flex-col overflow-hidden">
          <ModalHeaderStyle header={"Order Print"} onClose={onClose} />

          {/* Scrollable Content */}
          <div ref={printRef} className="flex-1 overflow-y-auto p-4" id="main">
            <Grid container spacing={2} className="text-sm mb-4">
              <Grid item xs={6}>
                <div className="flex">
                  <strong className="w-[100px]">Order No.</strong> :
                  <div className="ml-1">
                    {details[0] ? details[0]?.items[0]?.ORDER_NO : ""}
                  </div>
                </div>
                <div className="flex">
                  <strong className="w-[100px]">Order Type</strong> :
                  <div className="ml-1">
                    {details[0]
                      ? details[0]?.items[0]?.ORDER_TYPE || "N/A"
                      : "N/A" || "N/A"}
                  </div>
                </div>
                <div className="flex">
                  <strong className="w-[100px]">Supplier</strong> :
                  <div className="ml-1">
                    {details[0]
                      ? details.map((o) => o.name).join(", ")
                      : "N/A" || "N/A"}
                  </div>
                </div>
              </Grid>
              <Grid item xs={6} className="text-right flex justify-end">
                <div>
                  <div className="flex">
                    <strong className="w-[120px] text-left">Date</strong> :
                    <div className="ml-1">
                      {details[0]
                        ? moment(details[0].items[0].DATE).format("DD/MM/YYYY")
                        : ""}
                    </div>
                  </div>
                  <div className="flex">
                    <strong className="w-[120px]  text-left">
                      Purchase Bill No.{" "}
                    </strong>{" "}
                    :
                    <div className="ml-1">
                      {details[0] ? details[0].items[0].PURCHASE_BILL_NO : ""}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>

            {details.map((item, index) => {
              return (
                <div key={index} className="mb-8 page-break">
                  <table className="w-full border border-gray-400 text-sm mb-2">
                    <thead className="bg-gray-100">
                      <tr>
                        <th
                          style={{
                            width: "4px",
                          }}
                          className="py-2 px-2  text-left"
                        >
                          S. No.
                        </th>
                        <th className="py-2 px-2 text-left w-[80px]">Party</th>

                        <th className="py-2 px-2 text-left w-[140px]">Item</th>
                        <th className="py-2 px-2 text-center w-[50px]">Qty</th>
                        <th className="py-2 px-2 text-right w-[50px]">
                          Net Price
                        </th>
                        <th className="py-2 px-2 text-right w-[50px]">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.items.map((item, i) => (
                        <tr key={i} className="border-t">
                          <td className="py-1 px-2">{i + 1}</td>
                          <td className="py-1 px-2">{item.NAME}</td>

                          <td className="py-1 px-2">{item.ITEMNAME}</td>
                          <td className="py-1 px-2 text-center">{item.QNTY}</td>
                          <td className="py-1 px-2 text-right">
                            {item.PUR_PRICE.toFixed(2)}
                          </td>
                          <td className="py-1 px-2 text-right">
                            {item.AMOUNT.toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="border-t font-semibold">
                        <td colSpan="5" className="py-2 px-2 text-right">
                          Total:
                        </td>
                        <td className="py-2 px-2 text-right">
                          {calcTotal(item.items).toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              );
            })}
          </div>

          {/* Fixed Print Button */}
          <div className="bg-white p-3 print:hidden sticky bottom-0 border-t border-gray-300 text-right">
            <button
              onClick={handlePrint}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Print
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OrderReceiptModal;
